import axios from "axios";

const BASE_URL = "https://zola.technology/api";

// Get headers with Bearer token
const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
  "Content-Type": "application/json",
});

/** 
 * Create a referral program
 * @param {string} referral_link - The URL to share with referrals
 * @param {string} referral_message - The message accompanying the referral link
 */
export const createReferralProgram = async (referral_link, referral_message) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/company/referral/create/`,
      {
        referral_link,
        referral_message,
      },
      {
        headers: getAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    if (error.response?.status === 409) {
      console.warn("Referral program already exists.");
    } else {
      console.error("Error creating referral program:", error);
    }
    throw error;
  }
};

/**
 * Fetch the existing referral program for the authenticated company
 */
export const getReferralProgram = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/company/referral/get/`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      console.warn("Referral program not found.");
    } else {
      console.error("Error fetching referral program:", error);
    }
    return null;
  }
};

/**
 * Update the referral program details
 * @param {string} referral_link - Updated referral link
 * @param {string} referral_message - Updated referral message
 */
export const updateReferralProgram = async (referral_link, referral_message) => {
  try {
    const response = await axios.patch(
      `${BASE_URL}/company/referral/update/`,
      {
        referral_link,
        referral_message,
      },
      {
        headers: getAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating referral program:", error);
    throw error;
  }
};
